/* eslint-disable @next/next/no-img-element */
import { TestimonialCardSb } from '@/components/findex-connect/types/component-types-sb'

import { StarIcon } from '../Icons/StarIcon/StarIcon'
import { CarouselItem } from '../ui/carousel'

export type TestimonialCard = {
  rating: number
  customerName: string
  customerTitle: string
  reviewText: string
  backgroundColor?: string
  image: {
    url: string
    alt: string
  }
  className?: string
  isLastItem?: boolean
}

export const TestimonialCard: React.FC<Partial<TestimonialCardSb>> = ({
  rating,
  customerName,
  customerTitle,
  backgroundColor,
  reviewText,
  image,
  className,
  isLastItem = false,
}) => {
  const { filename, alt } = image || {}
  return (
    <CarouselItem
      is="div"
      className={
        `TESTIMONIAL-CAROUSEL-ITEM flex h-[700px] w-full max-w-[1200px] basis-5/6 flex-col gap-6 overflow-hidden rounded-xl pl-0 select-none md:h-[560px] md:basis-4/5 md:flex-row md:gap-0 ` +
        className +
        (isLastItem ? ` mr-[16%] md:mr-[20%]` : ``)
      }
      style={{
        backgroundColor: backgroundColor || '#EDECE6',
      }}
    >
      <div className="IMAGE-CONTAINER min-h-[220px] w-full bg-black/10 md:min-h-full md:w-1/2">
        <img
          src={filename || ''}
          alt={alt || 'Customer Image'}
          width={'100%'}
          height={'100%'}
          className="h-full w-full object-cover"
        />
      </div>
      {rating && reviewText && customerName && customerTitle && (
        <div className="TESTIMONIAL-CONTENT flex h-full flex-col p-3 md:w-1/2 md:justify-between md:p-10 md:pr-4">
          <div className="RATING-CONTAINER flex gap-[2px]">
            {Array.from({ length: Number(rating) })?.map((_, index) => (
              <StarIcon key={`star-${index}`} />
            ))}
          </div>
          <div className="REVIEW-TEXT py-4 pr-5">
            <p className="para-lg text-prominent mb-2 line-clamp-6 leading-[1.5] text-wrap break-words">
              {reviewText}
            </p>
          </div>

          <div className="CUSTOMER-INFO md:mt-none mt-auto flex flex-col gap-1">
            <h3 className="CUSTOMER-NAME text-prominent text-xl leading-none font-semibold md:!text-2xl md:!leading-none">
              {customerName}
            </h3>
            <p className="CUSTOMER-TITLE text-subtle-light text-lg font-normal text-wrap break-words">
              {customerTitle}
            </p>
          </div>
        </div>
      )}
    </CarouselItem>
  )
}
